
import { CalendarTemplate } from 'src/app/models/CalendarTemplate';
import { IVisitTypes } from 'src/app/models/IVisitTypes';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { IClinicTimeZone } from 'src/app/models/IClinicTimeZone';

export interface visitSlot {
  visit: IVisitTypes;
  color: string;
  isActive: boolean;
}

//fixme change to interface?
export class timeSlotDialogModel {
  visitSlotList: visitSlot[];
  chosenId: number;
  duration: number;
  startTime: string;
  numBookings: number;
}

export class CopyTemplateDialogModel {
  providersList: IUserDetails[];
  allLocations: IClinicTimeZone[];
  selectedTemplate: CalendarTemplate;
}

export interface AssignTemplateDialogModel {
  templateList: CalendarTemplate[];
  startDate: Date;
  endDate: Date;
  //dayList: string[];
}

export interface StartEndTime {
  startTime: string;
  endTime: string;
  visitTypeId: number;
  bookinglimit: number;
}

export interface StartEndDateRange {
  startDate: Date;
  endDate: Date;
  dayOfWeek: string;
}